<template src='./new.pug' lang='pug'></template>

<script>

import vSelect from 'vue-select'
import Draggable from 'vuedraggable'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import Attribute from '../../../registration/attributesSet/Attribute'
import NewAttributeModal from '../../../registration/attributesSet/NewAtributeModal'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'AttributesSetNew',

  components: {
    vSelect,
    Draggable,
    PageTitle,
    FilterPortlet,
    ButtonPrimary,
    Attribute,
    NewAttributeModal
  },

  data () {
    return {
      requestSent: false,
      editingAttribute: {},
      isLoadingData: false,
      attributeSet: {
        id: null,
        name: '',
        linkType: {
          type: null,
          description: null
        },
        inUse: false
      },
      linkTypes: [
        {
          type: 'E',
          description: this.$t('conjuntoAtributo.labels.E')
        },
        {
          type: 'MF',
          description: this.$t('conjuntoAtributo.labels.MF')
        },
        {
          type: 'CL',
          description: this.$t('conjuntoAtributo.labels.CL')
        }
      ],
      attributes: [],
      shown: false
    }
  },

  computed: {
    attributeSetToEdit () {
      return this.$store.getters.attributeSetToEdit
    },

    attTypesAviable () {
      let aviables = []
      if (!!this.$store.getters.attributesSetList && this.$store.getters.attributesSetList.length > 0) {
        aviables = this.linkTypes.filter(type => {
          let link = this.$store.getters.attributesSetList.find(item => item.linkType === type.type)
          return link === undefined || link === null
        })
      } else {
        aviables = this.linkTypes
      }
      return aviables
    }
  },

  watch: {
    attributeSet: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.attributeSet, attributes: [...this.attributes] }))
      },
      deep: true
    },
    attributes: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.attributeSet, attributes: [...this.attributes] }))
      },
      deep: true
    }
  },

  methods: {
    updateAttributesList (newList) {
      this.attributes = newList
      this.$root.$refs.notification.info('conjuntoAtributo.sucesso.adicionadoOk')
    },

    createOrEditAttribute (attOrder) {
      if (!attOrder) {
        this.editingAttribute = null
      } else {
        this.editingAttribute = this.attributes[attOrder - 1]
        trackAnalyticsEvent(this, 'action-click', 'edit-atributo', attOrder)
      }
      this.shown = true
    },

    validate () {
      this.$validator.validateAll()
        .then(result => {
          if (!this.checkAttributesWithSameName()) {
            this.$root.$refs.notification.error('conjuntoAtributo.erro.nomesDuplicados', 'conjuntoAtributo.erro.criarConjunto')
          } else if (result) {
            this.saveAttributeSet({
              id: this.attributeSet.id,
              name: this.attributeSet.name,
              linkType: this.attributeSet.linkType,
              attributes: this.attributes
            })
          } else {
            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'conjuntoAtributo.erro.criarConjunto')
          }
        })
    },

    checkAttributesWithSameName () {
      const attributeNames = this.attributes.map(att => att.name)
      return attributeNames.length === new Set(attributeNames).size
    },

    backToList () {
      this.$router.push(PATHS.LIST_ATTRIBUTES_SET)
    },

    saveAttributeSet (attributeSet) {
      this.requestSent = true
      this.$store.dispatch('saveAttributeSet', attributeSet)
        .then(response => {
          this.$root.$refs.notification.success(response.message)
          this.$store.dispatch('setHasUnsavedChanges', false)
          this.$router.push(PATHS.LIST_ATTRIBUTES_SET)
        })
        .catch(err => {
          this.$root.$refs.notification.error(err.message)
          if (this.attributeSetToEdit && this.attributeSetToEdit.id) {
            this.$store.dispatch('getAttributeSetById', this.attributeSetToEdit.id)
              .then(attributeSet => {
                this.$store.dispatch('setAttributesSetToEdit', attributeSet)
              })
              .catch(error => this.$root.$refs.notification.error(error.message))
          }
        })
        .finally(() => {
          this.requestSent = false
        })
    },

    removeAttributeHandler (attOrder) {
      trackAnalyticsEvent(this, 'action-click', 'remove-atributo', attOrder)
      this.attributes.splice(attOrder - 1, 1)
    }
  },

  created () {
    if (this.attributeSetToEdit) {
      this.attributeSet = { ...this.attributeSetToEdit }
      this.attributeSet.linkType.description = this.$t(this.attributeSet.linkType.description)
      this.attributes = [...this.attributeSet.attributes]
    }
    this.defaultObject = { ...this.attributeSet, attributes: [...this.attributes] }
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
  }
}

</script>

<style scoped>
.categories-header {
  margin-bottom: 0;
}

.categories-header>div {
  text-align: center;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
  transition: all .2s;
}
</style>



// WEBPACK FOOTER //
// New.vue?e70d5c48